
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";
import BlockImage from "../../Block/BlockImage";

function AISeminar() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>Historical Development of Artificial Intelligence and Machine Learning</BlockTitle>
          {/* <BlockSubtitle>Autonomous Camera Drones for Interactive Experiences in Extended Reality Telepresence Applications with enhanced Naturalness</BlockSubtitle> */}
        </BlockContent>
        <BlockContent>
          <BlockText>A lecture about the historical development of artificial intelligence and machine learning, covering key concepts, milestones, and influential approaches from early symbolic AI to modern deep learning.</BlockText>
        </BlockContent>
      </Block>


      <Block gridTemplateColumns="1200px">
        <BlockContent>
              <iframe
      src={`${process.env.PUBLIC_URL}/pdf/Seminar-AI-History.pdf`}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Anzeige"
    />
        </BlockContent>
      </Block>

      <Footer/>
    </div>
  );
}

export default AISeminar;